import { CRMAPIBase } from "@api/crmApiBase";
import { ScheduleListResp } from "@api/responseModels/worker/schedule/scheduleListResponse";
import { ScheduleResp } from "@api/responseModels/worker/schedule/scheduleResponse";
import { TScheduleCreateOwner, TScheduleFields, TScheduleUpdateFields } from "@components/schedule/common/types";

class ScheduleGroup extends CRMAPIBase {
    async saveSchedule(
        owner: TScheduleCreateOwner,
        fields: TScheduleFields
    ) {
        const result = await this.post<ScheduleResp>('/schedules', {
            ...owner,
            title: fields.title,
            start_time: fields.start_time,
            end_time: fields.end_time,
            start_schedule_at: fields.start_schedule_at,
            schedule_type: fields.schedule_type,
            day_offs: fields.day_offs,
            schedule_days: fields.schedule_days,
            breaks: fields.breaks,
        });
        return result;
    }

    async getScheduleList(crm_id: number) {
        const result = await this.get<ScheduleListResp>('/schedules', {
            crm_id
        });
        return result;
    }

    async updateSchedule(
        crm_id: number,
        id: number,
        fields: TScheduleUpdateFields
    ) {
        const result = await this.put<ScheduleResp>(`/schedules/${id}`, {
            crm_id,
            title: fields.title,
            start_time: fields.start_time,
            end_time: fields.end_time,
            start_schedule_at: fields.start_schedule_at,
            schedule_type: fields.schedule_type,
            day_offs: fields.day_offs,
            schedule_days: fields.schedule_days,
            breaks: fields.breaks,
            exception_days: fields.exception_days,
        });
        return result;
    }

    async removeSchedule(crm_id: number, id: number) {
        const result = await this.delete<ScheduleResp>(`/schedules/${id}`, {
            crm_id
        });
        return result;
    }

    async restoreSchedule(crm_id: number, id: number) {
        const result = await this.post<ScheduleResp>(`/schedules/${id}/restore`, {
            crm_id
        });
        return result;
    }

    async detachScheduleTemplate(crm_id: number, id: number) {
        const result = await this.delete<ScheduleResp>(`/schedules/${id}/template`, {
            crm_id
        });
        return result;
    }
}

export { ScheduleGroup };